import React from "react";
import EditButton from "./Buttons/EditButton";
import { Box, Modal } from "@mui/material";
import { useState } from "react";
import EditRole from "./forms/EditRole";
import DeleteButtonUserData from "./Buttons/DeleteButtonUserData";
import DeleteUserModal from "./Notes/DeleteUserModal";

function FormLineMedium5(props) {
  const [isHovered, setIsHovered] = useState(false);
  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 420,
    maxWidth: "92vw",
    borderRadius: 6,
    bgcolor: "background.paper",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
    padding: "16px",
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 440,
    maxWidth: "92vw",
    borderRadius: 6,
    backgroundColor: "white",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
    padding: "16px",
  };

  const [openEditRole, setOpenEditRole] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleOpenEditRole = () => setOpenEditRole(true);
  const handleCloseEditRole = () => setOpenEditRole(false);

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMedium5 light-grey-form"
          : "formLineMedium5 grey-form"
      }
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: "90%",
        marginLeft: 40,
        marginBottom: 8,
        backgroundColor: isHovered ? "#d9e0ea" : "white",
        borderRadius: 5,
        height: 60,
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        boxSizing: "border-box",
        borderBottom: "1px solid lightgrey",
        cursor: "default",
      }}
    >
      <Modal
        open={openEditRole}
        onClose={handleCloseEditRole}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        keepMounted
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15,23,42,0.45)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
      >
        <Box sx={styleModalGeneral}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 16 }}>Edit role</div>
          </div>
          <EditRole
            closemodal={handleCloseEditRole}
            userName={props.userName}
            roleUser={props.userRole}
            userId={props.userId}
          />
        </Box>
      </Modal>
      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        keepMounted
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15,23,42,0.45)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
      >
        <Box sx={styleDeleteModal}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 16, color: "#b91c1c" }}>
              Delete user
            </div>
          </div>
          <DeleteUserModal onClose={closeDeleteModal} uid={props.userId} />
        </Box>
      </Modal>

      <div
        className="role-line-block1"
        style={{
          flex: "0 0 28%",
          paddingLeft: 5,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.userEmail}
      </div>
      <div
        className="role-line-block2"
        style={{
          flex: "0 0 22%",
          fontWeight: 500,
          color: "black",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.userName}
      </div>
      <div
        className="role-line-block3"
        style={{
          flex: "0 0 18%",
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.userRole}
      </div>
      <div
        className="role-line-block3"
        style={{
          flex: "0 0 18%",
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.userPhone}
      </div>

      {/* <div className="role-line-block3"> */}
      <div
        className="role-line-block3"
        style={{
          flex: "0 0 14%",
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        {/* <EditButton title="Edit" handleOpen={handleOpenEditRole} /> */}
        <EditButton
          title="Edit"
          handleOpen={handleOpenEditRole}
          onClick={(e) => {
            e.stopPropagation();
            handleOpenEditRole();
          }}
        />
        {/* <DeleteButtonUserData
          handleOpen={openDeleteModal}
          closeModal={closeDeleteModal}
        /> */}
        <DeleteButtonUserData
          handleOpen={(e) => {
            if (e && e.stopPropagation) e.stopPropagation();
            openDeleteModal();
          }}
          onClick={(e) => {
            e.stopPropagation();
            openDeleteModal();
          }}
          closeModal={closeDeleteModal}
        />
      </div>
    </div>
  );
}

export default FormLineMedium5;
